module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-md-12 text-justify"
  }, [_c('h1', {
    staticClass: "centered"
  }, [_vm._v("Курсы")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n          «Курсы экскурсоводов по Санкт-Петербургу» – это образовательный проект \n          "), _vm._v(" для тех, кто хочет сделать хобби своей основной профессией\n          и пополнить арсенал своих знаний.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Обучение на наших курсах экскурсоводов  открывает потрясающие перспективы перед каждым слушателем:\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("показать множеству людей Санкт-Петербург таким, каким его видите Вы!")]), _vm._v(" "), _c('li', [_vm._v("расширить свой кругозор")]), _vm._v(" "), _c('li', [_vm._v("получать знания по истории, культуре, архитектуре  и экскурсоведению  от лучших специалистов Санкт-Петербурга")]), _vm._v(" "), _c('li', [_vm._v("получить аккредитацию  в Городском  туристско-информационном  центре")]), _vm._v(" "), _c('li', [_vm._v("возможность трудоустройства  в  компанию по приему туристов в Санкт-Петербурге")]), _vm._v(" "), _c('li', [_vm._v("существенно увеличить доход в период летних и зимних каникул, совмещая любимое хобби с работой")])]), _vm._v(" "), _c('p', [_vm._v("\n          Наши курсы — это действительно фундаментальное образование, а не поверхностный\n          взгляд на историю и культуру нашего города. Своей миссией мы считаем формирование\n          нового поколения петербургских экскурсоводов для поддержания традиций и культуры нашего города.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "font-italic"
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    staticStyle: {
      "color": "red",
      "font-size": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Мы позаботились о том, чтобы занятия начинались в удобное для работающего человека время,\n          а также о том, чтобы Вам было удобно до нас добираться. И каждого, кто изучал стоимость обучения профессии\n          экскурсоводов, обязательно порадует сочетание цены и качества обучения на наших курсах.\n        ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b7c0180"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutCourses.vue
// module id = 222
// module chunks = 1